<script setup>
import YearMonthPicker from '@/components/Overtime/YearMonthPicker.vue';
import CompensatoryLeaveTable from '@/components/Overtime/CompensatoryLeaveTable.vue';
import { onMounted, ref } from 'vue';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const year = ref(dayjs().year());
const month = ref(dayjs().month() + 1);
const is_approved = ref(true);
const leaves = ref([]);
const perMonth = ref(0);
const perYear = ref(0);
const remainHours = ref(0);
const company = ref({
  name: '',
  break_hours: 0,
  break_time: '',
});

const goto = path => {
  window.location.href = path;
};
async function getMe() {
  const response = await axios.get('/api/me');
  return response.data.data;
}
async function getLeaves() {
  const response = await axios.get('/api/compensatory-leaves', {
    params: {
      year: year.value,
      month: month.value,
    },
  });
  leaves.value = response.data.data;
}

async function changeYear(operator) {
  if (operator === '+') {
    year.value++;
  } else if (operator === '-') {
    year.value--;
  }
  await getLeaves();
  await totalLeaves();
}

async function changeMonth(value) {
  month.value = +value;
  await getLeaves();
  await totalLeaves();
}

async function changeIsApproved(value) {
  is_approved.value = value;
  await getLeaves();
}

async function totalLeaves() {
  const response = await axios.get('/api/compensatory-leaves/total', {
    params: {
      year: year.value,
      month: month.value,
    },
  });
  perYear.value = response.data.data.year;
  perMonth.value = response.data.data.month;
  remainHours.value = response.data.data.remain_hours;
}

function companyBreakHours(begin, end) {
  const beginTime = dayjs(begin, 'HH:mm');
  const endTime = dayjs(end, 'HH:mm');
  return endTime.diff(beginTime, 'hour', true);
}
function setCompanyData(me) {
  company.value.name = me.company.name;
  company.value.break_time = `${me.company.break_time_begin} - ${me.company.break_time_end}`;
  company.value.break_hours = companyBreakHours(
    me.company.break_time_begin,
    me.company.break_time_end,
  );
}
onMounted(async () => {
  await getLeaves();
  await totalLeaves();
  const me = await getMe();
  setCompanyData(me);
});
</script>

<template>
  <div class="flex-col w-full">
    <header class="flex justify-between w-full">
      <div>
        <button
          @click="goto('/user/leaves/create?leave_type=other&other_type=compensatory')"
          class="px-2 py-1 text-lg text-white bg-gray-600 rounded"
        >
          Apply
        </button>
      </div>
    </header>
    <div
      className="mt-4 bg-emerald-50 border-2 border-emerald-200 rounded-xl p-6 text-center"
    >
      <div className="text-sm text-emerald-700 font-medium mb-2">Remain Hours</div>
      <div className="text-6xl font-bold text-emerald-600">{{ remainHours }}</div>
    </div>
    <div class="grid grid-cols-2 py-4 mt-2 justify-items-center">
      <div>
        <div class="text-2xl font-bold text-center text-emerald-600">
          {{ perMonth }}
        </div>
        <div>hours / month</div>
      </div>
      <div>
        <div class="text-2xl font-bold text-center text-emerald-600">{{ perYear }}</div>
        <div>hours / year</div>
      </div>
    </div>
    <div>
      <YearMonthPicker
        :year="year"
        :month="month"
        :is_approved="is_approved"
        @setYear="changeYear"
        @setMonth="changeMonth"
        @setIsApproved="changeIsApproved"
      />
    </div>
    <hr class="my-4" />
    <div class="p-4 mb-4 text-center border-2 border-indigo-200 bg-inherited-50 rounded-xl">
      Break Time: {{ company.break_time }} ({{ company.break_hours }} hours)
    </div>
    <CompensatoryLeaveTable :leaves="leaves" @show="getLeaves" :company="company" />
  </div>
</template>
